export default __webpack_public_path__ + "static/media/STLOUIS.f4620c44.jpg";